import * as React from "react"

import { cn } from "@/lib/utils"

const CJK_PATTERN = /[\u3400-\u9fff\uf900-\ufaff]/
const LETTER_PATTERN = /\p{L}/gu

export function getAvatarInitials(name: string | null | undefined): string {
  const trimmed = name?.trim() ?? ''
  if (!trimmed) return '?'

  const firstChar = Array.from(trimmed)[0]
  if (CJK_PATTERN.test(firstChar)) return firstChar

  const letters = trimmed.match(LETTER_PATTERN) ?? []
  const initials = letters.slice(0, 2).join('').toUpperCase()
  return initials || firstChar.toUpperCase()
}

function Avatar({
  name,
  className,
  ...props
}: React.ComponentProps<"span"> & {
  name: string | null | undefined
}) {
  return (
    <span
      aria-hidden
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full bg-[var(--nf-ember-soft)] font-semibold text-[var(--nf-ember)]",
        className,
      )}
      {...props}
    >
      {getAvatarInitials(name)}
    </span>
  )
}

export { Avatar }
